import {GetProceduresListParams} from 'domain/usecases/private/my-hospitalization/get-procedures-list';
import {makeGetProceduresList} from 'main/factories/usecases/private/my-hospitalization/get-procedures-list-factory';

export const getProceduresList = async (params: GetProceduresListParams) => {
	try {
		const response = await makeGetProceduresList().get(params);

		if (typeof response === 'string') {
			return {
				pages: 0,
				items: [],
			};
		}

		const pages = Math.ceil(response.totalElements / params.size);

		return {
			pages,
			items: response.content,
		};
	} catch (error) {
		throw new Error();
	}
};
